





















import Vue from 'vue'

const STAR_COUNT = 5
const createArrayFromCount = (count: number) =>
  Array.from({ length: count }).map((_, i) => i + 1)

export default Vue.extend({
  name: 'Stars',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    size: {
      type: String,
      default: 'normal',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    stars: createArrayFromCount(STAR_COUNT),
  }),
  computed: {
    floorValue(): number {
      return Math.floor(Number(this.value))
    },
  },
})
